import React from "react";
import "./Dropdown.css";
interface DropdownProps {
  name?: string;
  label?: string;
  disabled: boolean;
  iserror?: boolean;
  errorMessage?: string | undefined | string[];
  value?: string | number;
  options: string[];
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

export const Dropdown = ({
  name,
  label,
  disabled,
  iserror,
  errorMessage,
  value,
  options,
  onChange,
}: DropdownProps) => {
  console.log(`The value received for ${name} `, value);
  return (
    <div
      className="dropdown-group"
      style={disabled ? { pointerEvents: "none", opacity: 0.4 } : {}}>
      <div className="dropdown-wrapper-label">
        <label className="dropdown-label">
          <p>{label}</p>
        </label>
      </div>

      <div className="dropdown-wrapper-select">
        <select
          onChange={onChange}
          className="dropdown-select"
          name={name}
          value={value}>
          <option value="">-- Select an option --</option>
          {options.map((option, index) => (
            <option className="dropdown-option" key={index} value={option}>
              {option}
            </option>
          ))}
        </select>
        {iserror && errorMessage && <div className="error">{errorMessage}</div>}
      </div>
    </div>
  );
};
